class RepresentDropdown extends HTMLElement {
  constructor() {
    super();
    this.dropdownButton = document.getElementById(this.getAttribute('aria-labelledby'));
    this.dropdownBackdrop = document.getElementById(`${this.dataset.optionType}-backdrop`);
  }

  connectedCallback() {
    this.initDropdown();
  }

  updateLabel(label) {
    this.dropdownButton.querySelector("[selected-option]").textContent = label;
  }

  animateDropdown(show) {
    if (show) {
      requestAnimationFrame(() => {
        this.classList.add("!opacity-100", "!translate-y-[-12px]");
      });
      return;
    }

    requestAnimationFrame(() => {
      this.classList.remove("!opacity-100", "!translate-y-[-12px]");
    });
  }

  animateBackdrop(show) {
    const transitionEnter = ["transition", "ease-out", "duration-300"];
    const enterStart = ["opacity-0"];
    const enterEnd = ["opacity-100"];

    const transitionLeave = ["transition", "ease-in", "duration-300"];
    const leaveStart = ["opacity-100"];
    const leaveEnd = ["opacity-0"];

    this.dropdownBackdrop.classList.remove(...enterStart, ...enterEnd, ...leaveStart, ...leaveEnd);

    if (show) {
      this.dropdownBackdrop.classList.add(...transitionEnter, ...enterStart);
      requestAnimationFrame(() => {
        this.dropdownBackdrop.classList.remove(...enterStart);
        this.dropdownBackdrop.classList.add(...enterEnd);
      });
      return;
    }

    this.dropdownBackdrop.classList.add(...transitionLeave, ...leaveStart);
    requestAnimationFrame(() => {
      this.dropdownBackdrop.classList.remove(...leaveStart);
      this.dropdownBackdrop.classList.add(...leaveEnd);
    });
  }

  toggleZendesk(isExpanded) {
    if (!document.querySelector('#launcher')) return;

    document.querySelector('#launcher').style.display = isExpanded ? 'none' : 'block';
  }

  async toggleDropdown(isExpanded) {
    const desktopMenu = document.querySelector('desktop-menu');

    this.dropdownButton.setAttribute("aria-expanded", isExpanded);

    if (isExpanded) {
      requestAnimationFrame(() => {
        this.parentElement.classList.remove('hidden');
        this.classList.remove("hidden", "translate-y-[calc(100%+12px)]");
        this.dropdownBackdrop.classList.remove("hidden");
        this.dropdownButton.querySelector('svg').style.transform = 'rotate(180deg)';
        this.animateBackdrop(true);
        this.animateDropdown(true);
      });

      await window.waitForPaint();
      enableScrollLock(this);
      trapFocus(this);
      this.querySelector("a, button")?.focus();
    } else {
      requestAnimationFrame(() => {
        this.dropdownButton.querySelector('svg').style.transform = '';
        this.animateBackdrop(false);
        this.animateDropdown(false);
        setTimeout(() => {
          this.classList.add("hidden", "translate-y-[calc(100%+12px)]");
          this.dropdownBackdrop.classList.add("hidden");
          this.parentElement.classList.add('hidden');
        }, 300);
      });

      await window.waitForPaint();
      disableScrollLock(this);
      removeTrapFocus(this);
      this.dropdownButton.focus();
    }

    desktopMenu.classList.toggle('!z-10', isExpanded);
  }

  initDropdown() {
    const dropdownOptions = this.querySelectorAll("a, button:not([data-exclude-dropdown-toggle])");

    this.dropdownButton.addEventListener("click", () => {
      const isExpanded = this.dropdownButton.getAttribute("aria-expanded") === "true";

      document.querySelectorAll(`represent-dropdown:not(#${this.id})`).forEach(dropdown => {
        dropdown.toggleDropdown(false);
      });

      this.toggleZendesk(!isExpanded);
      this.toggleDropdown(!isExpanded);
    });

    this.dropdownBackdrop.addEventListener('click', () => {
      this.toggleDropdown(false);
      this.toggleZendesk(false);
    });

    this.dropdownButton.addEventListener("keydown", (e) => {
      if (e.key === "ArrowDown") {
        e.preventDefault();
        this.toggleZendesk(true);
        this.toggleDropdown(true);
      }
    });

    this.parentElement.addEventListener("click", (e) => {
      if (e.target.nodeName !== 'BUTTON') {
        this.toggleDropdown(false);
        this.toggleZendesk(false);
      }
    });

    this.addEventListener("keydown", (e) => {
      const currentIndex = Array.from(dropdownOptions).indexOf(document.activeElement);

      if (e.key === "ArrowRight") {
        e.preventDefault();
        const nextIndex = (currentIndex + 1) % dropdownOptions.length;
        dropdownOptions[nextIndex]?.focus();
      }

      if (e.key === "ArrowLeft") {
        e.preventDefault();
        const prevIndex = (currentIndex - 1 + dropdownOptions.length) % dropdownOptions.length;
        dropdownOptions[prevIndex]?.focus();
      }

      if (e.key === "Escape") {
        e.preventDefault();
        this.toggleDropdown(false);
        this.toggleZendesk(false);
      }
    });

    dropdownOptions.forEach((option) => {
      option.addEventListener("click", () => {
        const selectedText = option.querySelector('[data-option-label]').textContent.trim();
        this.updateLabel(selectedText);

        dropdownOptions.forEach((item) => {
          item.setAttribute('aria-checked', 'false');
        });

        option.setAttribute('aria-checked', 'true');

        this.toggleDropdown(false);
        this.toggleZendesk(false);
      });
    });
  }
}

customElements.define("represent-dropdown", RepresentDropdown);
